import Vue from 'vue';
import BaseApi from './baseApi.js';
import {
    Message,
} from 'element-ui';

function getUserIP(onNewIP) { //  onNewIp - your listener function for new IPs
    //compatibility for firefox and chrome
    var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    var pc = new myPeerConnection({
        iceServers: []
    }),
        noop = function () { },
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
        key;

    function iterateIP(ip) {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
    }

    //create a bogus data channel
    pc.createDataChannel("");

    // create offer and set local description
    pc.createOffer().then(function (sdp) {
        sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return;
            line.match(ipRegex).forEach(iterateIP);
        });

        pc.setLocalDescription(sdp, noop, noop);
    }).catch(function (reason) {
        // An error occurred, so handle the failure to connect
    });

    //sten for candidate events
    pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
    };
}

// Usage
export default class Util {
    constructor() {
        throw new Error('静态类不需要初始化');
    }
    static getLocation = function (callback, errCallback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                let latitude = position.coords.latitude
                let longitude = position.coords.longitude
                let geocoder = new qq.maps.Geocoder({
                    complete: function (result) {
                        callback && callback(result);
                    }
                });
                var coord = new qq.maps.LatLng(latitude, longitude);
                geocoder.getAddress(coord);
            }, errCallback || function (error) {
                callback && callback(null);
                switch (error.code) {
                    case 1:
                        console.log("位置服务被拒绝。");
                        break;
                    case 2:
                        console.log("暂时获取不到位置信息。");
                        break;
                    case 3:
                        console.log("获取位置信息超时。");
                        break;
                    default:
                        console.log("未知错误。");
                        break;
                }
            });
        } else {
            return null;
        }
    }
    static getLocationByIp() {
        getUserIP((ip) => {
            BaseApi.createRpcToken("/getLocationByIp", {
                key: 'ZQXBZ-ZTIKQ-VF753-GW4PJ-HWZHV-UQFO3',
                ip: ip
            }).then(
                data => {
                    this.signPersonList = data.datas.list;
                },
                err => { }
            ).catch(function (e) {
                errorLog(e);
            });;
        })

    }
    // 获取唯一值
    static getUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static compareTime(startDate, endDate, stratType = 'string', endType = 'string') {
        if (startDate && endDate) {
            var allStartDate = '';
            var allEndDate = '';
            if (stratType == 'string') {
                var startDateTemp = startDate.split(" ");
                var arrStartDate = startDateTemp[0].split("-");
                if (startDateTemp[1]) {
                    var arrStartTime = startDateTemp[1].split(":");
                    allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2], arrStartTime[0], arrStartTime[1], arrStartTime[2]);
                } else {
                    // var arrStartTime = startDateTemp[1].split(":");
                    allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2]);
                }
            } else {
                allStartDate = startDate;
            }
            if (endType == 'string') {
                var endDateTemp = endDate.split(" ");
                var arrEndDate = endDateTemp[0].split("-");
                if (endDateTemp[1]) {
                    var arrEndTime = endDateTemp[1].split(":");
                    allEndDate = new Date(arrEndDate[0], arrEndDate[1] - 1, arrEndDate[2], arrEndTime[0], arrEndTime[1], arrEndTime[2]);
                } else {
                    allEndDate = new Date(arrEndDate[0], arrEndDate[1] - 1, arrEndDate[2]);
                }

            } else {
                allEndDate = endDate;
            }
            if (allStartDate.getTime() >= allEndDate.getTime()) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
    static getNowDate() {
        var time = new Date();
        var year = time.getFullYear(); //获取年
        var month = time.getMonth() + 1; //或者月
        var day = time.getDate(); //或者天
        var hour = time.getHours(); //获取小时
        var minu = time.getMinutes(); //获取分钟
        var second = time.getSeconds(); //或者秒
        return `${year}-${month}-${day}  ${hour}:${minu}:${second}`
    }
    static compareTimeToNow(startDate, returnType = 'boolean') {
        if (startDate.length > 0) {
            var startDateTemp = startDate.split(" ");
            var arrStartDate = startDateTemp[0].split("-");
            var arrStartTime = startDateTemp[1].split(":");
            var allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2], arrStartTime[0], arrStartTime[1], arrStartTime[2]);
            var time = new Date();
            var year = time.getFullYear(); //获取年
            var month = time.getMonth(); //或者月
            var day = time.getDate(); //或者天
            var hour = time.getHours(); //获取小时
            var minu = time.getMinutes(); //获取分钟
            var second = time.getSeconds(); //或者秒
            var allEndDate = new Date(year, month, day, hour, minu, second);
            if (allStartDate.getTime() >= allEndDate.getTime()) {
                if (returnType == 'boolean') {
                    return true;
                } else {
                    return allStartDate;
                }

            } else {
                if (returnType == 'boolean') {
                    return false;
                } else {
                    return allEndDate;
                }
            }
        } else {
            return false;
        }
    }
    // 复制文字到剪贴板
    static copyToClipboard(text, callback) {
        var textArea;

        createTextArea(text);
        selectText();
        copyToClipboard();

        // 判断是不是ios端
        function isOS() {
            return navigator.userAgent.match(/ipad|iphone/i);
        }

        //创建文本元素
        function createTextArea(text) {
            textArea = document.createElement('textArea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '1000px';
            textArea.style.top = '0px';

            document.body.appendChild(textArea);
        }

        //选择内容
        function selectText() {
            var range,
                selection;

            if (isOS()) {
                range = document.createRange();
                range.selectNodeContents(textArea);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                textArea.setSelectionRange(0, 999999);
            } else {
                textArea.select();
            }
        }

        //复制到剪贴板
        function copyToClipboard() {
            try {
                if (document.execCommand("Copy")) {
                    if (callback) {
                        callback('success')
                    } else {
                        Message.success("复制成功");
                    }
                } else {
                    if (callback) {
                        callback('error')
                    } else {
                        Message.error("复制失败！请手动复制！");
                    }
                }
            } catch (err) {
                if (callback) {
                    callback('error')
                } else {
                    Message.error("复制错误！请手动复制！")
                }
            }
            document.body.removeChild(textArea);
        }
    }
    // 复制图片到剪贴板
    static copyImgToClipboard(url) {
        var canvas = document.createElement('canvas') // 创建一个画板
        let image = new Image()
        image.setAttribute("crossOrigin", 'Anonymous') //可能会有跨越问题
        image.src = url
        image.onload = () => {  // img加载完成事件
            canvas.width = image.width  //设置画板宽度
            canvas.height = image.height //设置画板高度
            canvas.getContext('2d').drawImage(image, 0, 0); //加载img到画板
            let url = canvas.toDataURL("image/png") // 转换图片为dataURL，格式为png
            clipboardImg(url) // 调用复制方法
        }
        async function clipboardImg(url) {
            try {
                const data = await fetch(url);
                const blob = await data.blob();
                await navigator.clipboard.write([
                    new window.ClipboardItem({
                        [blob.type]: blob
                    })
                ]);
                Message.success('复制成功')
            } catch (err) {
                Message.error('复制失败，请手动复制')
            }
        }
    }

    static environmentMethod() {
        var browser = {
            versions: (function () {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                return {
                    //移动终端浏览器版本信息
                    trident: u.indexOf("Trident") > -1, //IE内核
                    presto: u.indexOf("Presto") > -1, //opera内核
                    webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
                    gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
                    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                    android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
                    iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
                    iPad: u.indexOf("iPad") > -1, //是否iPad
                    webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
                };
            })(),
            language: (
                navigator.browserLanguage || navigator.language
            ).toLowerCase(),
        };
        var environment = "";
        if (browser.versions.ios) {
            //是否在IOS浏览器打开
            environment = "ios";
        }
        if (browser.versions.android) {
            //是否在安卓浏览器打开
            environment = "android";
        }
        return environment;
    }
}